import React, { useState } from 'react'
import AllCheckpointData from '../Dashboard/AllCheckpointData'
import { useCheckpoints, useUserPermissions } from '../../services/hooks';
import { Navigate } from 'react-router-dom';

const AllTrips = () => {
    const { checkpoints, isLoading } = useCheckpoints();
    const { userPermissions, isFetched } = useUserPermissions();
    const checkpointNumber = checkpoints[0]?.checkpointNumber;
    const checkpointType = checkpoints[0]?.checkpointType;
    const [tripCount, setTripCount] = useState(null);

  if ( isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getAllTrips?.value ) return <Navigate to="/not-authorized" replace />;
  return (
    <div>
      <div className="cust-row flex-algn-cent">
          <div className="cust-col-5">
            <h1 className="title">All Trips
              {tripCount !== null && (
                <span className="trip-count">({tripCount})</span>
              )}
            </h1>
          </div>
      </div>
      <hr className="bgg" />

      <div className="checkpoint-table-container">
        <div className="checkpoint-table">
          <AllCheckpointData forwordLink={`/checkpoints/${checkpointType}/${checkpointNumber}`} showPagination={true} showHeading={false} plantArray={true} showDownloadExcelButton={true} onTotalCountChange={setTripCount}/>
        </div>
      </div>
    </div>
  )
}

export default AllTrips